'use strict';

module.exports.rateQuoteGrid = function () {
    return `
        <div rv-if="data.datatype | = 'rate'">
            <div class="pure-g">
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-l">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-last"
                            rv-if="data.pricedata.last"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.thisweek| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr"
                                    rv-text="data.pricedata.last | numeraljs"
                                >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pure-u-1-1 pure-u-sm-1-2">
                    <div class="qmod-box-wrap qmod-box-wrap-r">
                        <div class="qmod-line-sep qmod-quote-element qmod-quote-element-exShName"
                            rv-if="data.key.exShName"
                        >
                            <div class="pure-u-1-2">
                                <div class="qmod-label qmod-textl">{tplLang.exchange| toLang tLang}</div>
                            </div>
                            <div class="pure-u-1-2">
                                <div class="qmod-data-point qmod-textr">
                                    <a class="qmod-tooltip"
                                        rv-title="data.key.exLgName"
                                        rv-on-mouseenter="data.qmtooltip"
                                        rv-text="data.key.exShName"
                                    >
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
};
